import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchLanguagesFailure, fetchLanguagesSuccess } from "entities/languages/actions";
import type { LanguageRequestPayload } from "entities/languages/types";

export function* fetchLanguagesSaga() {
  try {
    const payload: LanguageRequestPayload = yield apiFetch("language");
    yield put(
      fetchLanguagesSuccess({
        languages: payload.languages.map(({ code, native_name, choose_label }) => ({
          chooseLabel: choose_label,
          id: code,
          label: native_name,
        })),
      }),
    );
  } catch {
    yield put(fetchLanguagesFailure());
  }
}
